/* @flow */
import { createMuiTheme } from '@material-ui/core/styles';

const MuiBoxShadow: string = '0 1px 6px 0px rgba(0, 0, 0, 0.1), 0 6px 12px 0 rgba(0, 0, 0, 0.2)';
const MuiBoxShadowWhite: string =
  '0 1px 6px 0px rgba(0, 0, 0, 0.05), 0 6px 12px 0 rgba(0, 0, 0, 0.1)';

const theme: any = createMuiTheme({
  palette: {
    primary: {
      light: '#F26045',
      main: '#F26045',
      dark: '#F26045',
      contrastText: '#fff',
    },
    secondary: {
      light: '#2A3338',
      main: '#2A3338',
      dark: '#2A3338',
      contrastText: '#F3F3F2',
    },
    error: {
      light: '#d92700',
      main: '#d92700',
      dark: '#d92700',
      contrastText: '#fff',
    },
    text: {
      primary: '#2A3338',
      secondary: '#a3adb1',
      disabled: '#a3adb1',
    },
    action: {
      disabled: '#b0b0b0',
      disabledBackground: '#e0e0e0',
    },
  },
});

theme.props = {
  MuiButton: {
    disableRipple: true,
  },
  MuiCheckbox: {
    color: 'primary',
  },
  MuiIconButton: {
    disableRipple: true,
  },
  MuiMenuItem: {
    disableRipple: true,
  },
  MuiListItem: {
    button: false,
  },
  MuiTab: {
    disableRipple: true,
  },
  MuiRadio: {
    color: 'primary',
  },
  MuiTabs: {
    indicatorColor: 'primary',
  },
};

theme.overrides = {
  MuiButton: {
    root: {
      transition: 'box-shadow 0.3s ease, color 0.3s ease, backgorund-color 0.3s ease',
      color: '#2A3338',
      minHeight: 30,
      borderRadius: 2,
      minWidth: 80,
      padding: '6px 18px',
      fontSize: '0.85rem',
      fontFamily: 'Roboto Condensed',
      textTransform: 'uppercase',
      [theme.breakpoints.up('md')]: {
        fontSize: '0.9rem',
      },
    },
    contained: {
      boxShadow: null,
      border: 'none',
      backgroundColor: '#cccccc',
      '&:active': {
        boxShadow: MuiBoxShadow,
      },
      '&:hover': {
        boxShadow: MuiBoxShadow,
        backgroundColor: '#cccccc',
      },
    },
    outlined: {
      backgroundColor: '#ffffff',
      '&:hover': {
        boxShadow: MuiBoxShadowWhite,
        backgroundColor: '#ffffff',
      },
    },
  },
  MuiCardHeader: {
    action: {
      marginTop: 'auto',
      marginRight: 'auto',
    },
  },
  MuiCheckbox: {
    root: {
      height: 30,
      width: 30,
    },
  },
  MuiChip: {
    root: {
      backgroundColor: '#2a3338',
      height: 28,
      padding: '0 8px',
      fontSize: '0.9rem',
      margin: '0 6px 6px 0',
    },
    deletable: {
      '&:focus': {
        backgroundColor: '#2a3338',
      },
    },
    avatar: {
      fill: '#f26045',
      marginRight: 0,
      height: 28,
      width: 12,
      backgroundColor: 'transparent',
    },
    avatarChildren: {
      height: 12,
      width: 12,
    },
    label: {
      color: 'white',
      paddingRight: 10,
      paddingLeft: 8,
    },
    deleteIcon: {
      fill: '#f26045',
      height: 8,
      width: 8,
      margin: 0,
      pointerEvents: 'all',
    },
  },
  MuiDivider: {
    root: {
      backgroundColor: '#eaebec',
    },
  },
  MuiExpansionPanel: {
    root: {
      '&:before': {
        display: 'none',
      },
    },
    expanded: {
      margin: 0,
    },
  },
  MuiExpansionPanelDetails: {
    root: {
      padding: 0,
    },
  },
  MuiExpansionPanelSummary: {
    root: {
      minHeight: 40,
      padding: '0 16px',
      '&$expanded': {
        minHeight: 40,
      },
    },
    content: {
      margin: 0,
      '&$expanded': {
        margin: 0,
      },
    },
    expandIcon: {
      transform: 'translateY(-50%) rotate(0)',
      '&$expanded': {
        transform: 'translateY(-50%) rotate(0)',
      },
    },
  },
  MuiFormControl: {
    root: {
      width: '100%',
    },
  },
  MuiFormControlLabel: {
    root: {
      marginLeft: -8,
    },
  },
  MuiFormHelperText: {
    root: {
      marginTop: 6,
      lineHeight: '1.4em',
    },
  },
  MuiFormLabel: {
    root: {
      '&$focused': {
        color: '#0785ba',
      },
    },
  },
  MuiIconButton: {
    root: {
      height: 40,
      width: 40,
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  },
  MuiInput: {
    underline: {
      '&:before': {
        borderBottom: '1px solid #eaebec',
      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: '1px solid #a3adb1',
      },
      '&:after': {
        borderBottom: '1px solid #0785ba',
      },
      '&$disabled:before': {
        borderBottom: '1px solid #eaebec',
      },
    },
  },
  MuiInputAdnorment: {
    root: {
      maxHeight: 'none',
    },
  },
  MuiInputLabel: {
    root: {
      color: '#2a3338',
    },
    shrink: {
      color: '#a3adb1',
    },
  },
  MuiListItem: {
    default: {
      paddingTop: 6,
      paddingBottom: 6,
    },
    gutters: {
      [theme.breakpoints.up('sm')]: {
        paddingRight: 16,
        paddingLeft: 16,
      },
    },
  },
  MuiListItemText: {
    root: {
      padding: 0,
    },
  },
  MuiRadio: {
    root: {
      height: 30,
      width: 30,
    },
  },
  MuiSelect: {
    select: {
      '&:focus': {
        background: '#ffffff',
      },
    },
  },
  MuiSnackbarContent: {
    root: {
      background: '#2a3338',
      padding: '6px 18px',
      [theme.breakpoints.up('md')]: {
        minWidth: 128,
      },
    },
    action: {
      marginRight: 0,
      padding: 0,
    },
    message: {
      padding: '6px 0',
    },
  },
  MuiSvgIcon: {
    root: {
      fontSize: '20px',
    },
  },
  MuiSwitch: {
    switchBase: {
      width: 48,
    },
  },
  MuiTab: {
    root: {
      fontFamily: 'Roboto Condensed',
      minWidth: 80,
      [theme.breakpoints.up('sm')]: {
        minWidth: 100,
      },
      [theme.breakpoints.up('md')]: {
        minWidth: 120,
      },
    },
    label: {
      fontSize: '0.85rem',
      [theme.breakpoints.up('md')]: {
        fontSize: '0.9rem',
      },
    },
    labelContainer: {
      [theme.breakpoints.up('md')]: {
        paddingLeft: 20,
        paddingRight: 20,
      },
    },
  },
  MuiTablePagination: {
    caption: {
      fontSize: '0.9rem',
      color: '#2a3338',
    },
    input: {
      fontSize: '0.9rem',
    },
    selectRoot: {
      fontSize: '0.9rem',
      color: '#2a3338',
    },
  },
  MuiTabs: {
    root: {
      marginBottom: 12,
      boxShadow: 'inset 0px -1px 0px #eaebec',
      [theme.breakpoints.up(1920)]: {
        marginBottom: 24,
      },
    },
    indicator: {
      height: 3,
    },
  },
  MuiTooltip: {
    popper: {
      opacity: 1,
    },
    tooltip: {
      backgroundColor: '#2A3338',
      fontSize: '0.85rem',
      borderRadius: 3,
      boxShadow: MuiBoxShadow,
    },
  },
  MuiTypography: {
    body1: {
      fontSize: '0.95rem',
    },
    headline: {
      padding: '0 10px 0 0',
      overflow: 'hidden',
      fontFamily: '"Roboto Condensed", sans-serif',
      fontSize: '1.125rem',
      lineHeight: '18px',
      textOverflow: 'ellipsis',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    },
    display2: {
      fontFamily: '"Roboto Condensed", sans-serif',
      fontSize: '1.5rem',
      textTransform: 'none',
      color: 'hsl(198, 16%, 34%)',
      marginBottom: '10px',
    },
  },
};

export default theme;
